"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUpgradeLink = void 0;

var _links = require("self-service-api/core/utilities/links");

var _UpgradeProductProperties = _interopRequireDefault(require("self-service-api/constants/UpgradeProductProperties"));

var getUpgradeLink = function getUpgradeLink(_ref) {
  var source = _ref.source,
      upgradeProduct = _ref.upgradeProduct;

  if (!upgradeProduct) {
    return (0, _links.productsAndAddons)();
  }

  var upgradeLink = _UpgradeProductProperties.default[upgradeProduct].upgradeLink;

  if (upgradeLink) {
    return upgradeLink(source, upgradeProduct);
  }

  return (0, _links.productsAndAddons)();
};

exports.getUpgradeLink = getUpgradeLink;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/adapters/getUpgradeLink.js
// module id = 663
// module chunks = 5 6